// extracted by mini-css-extract-plugin
export default {"main_box":"HotelPage_main_box__98Mu5"};